<template>
  <div class="reports-client-details">
    <div class="card-gray">
      <div class="info-grid">
        <span class="label">Status</span>
        <span
          class="value"
          :class="client.finished_order ? 'active-badge' : 'incomplete-badge'"
        >
          {{ client.finished_order ? "Realizada" : "Incompleta" }}
        </span>

        <span class="label">Nome do cliente</span>
        <span class="value">{{ client.name }}</span>

        <span class="label">E-mail do cliente</span>
        <span class="value value-copyable" @click="copyEmail">
          {{ client.email }}
          <i class="ph ph-copy copy-icon ml-2" title="Copiar e-mail" />
        </span>

        <template v-if="client.document">
          <span class="label">CPF/CNPJ</span>
          <span class="value">{{ client.document }}</span>
        </template>

        <template v-if="client.phone">
          <span class="label">Telefone</span>
          <span class="value">{{ client.phone }}</span>
        </template>

        <template v-if="client.instagram">
          <span class="label">Instagram</span>
          <span class="value">{{ client.instagram }}</span>
        </template>

        <template v-if="client.country">
          <span class="label">País</span>
          <span class="value">{{ client.country }}</span>
        </template>
        <template v-if="client.offer && client.offer.name">
          <span class="label">Oferta</span>
          <span class="value">{{ client.offer.name }}</span>
        </template>
        <template v-if="client.plan && client.plan.name">
          <span class="label">Plano</span>
          <span class="value">{{ client.plan.name }}</span>
        </template>
      </div>
    </div>

    <div v-if="hasAddress" class="card-gray mt-4">
      <h6 class="text-semibold mb-4">Endereço</h6>
      <div class="info-grid">
        <template v-if="client.address && client.address.zipcode">
          <span class="label">CEP</span>
          <span class="value">{{ client.address.zipcode }}</span>
        </template>
        <template v-if="client.address && client.address.address">
          <span class="label">Endereço</span>
          <span class="value">{{ client.address.address }}</span>
        </template>
        <template v-if="client.address && client.address.number">
          <span class="label">Número</span>
          <span class="value">{{ client.address.number }}</span>
        </template>
        <template v-if="client.address && client.address.neighborhood">
          <span class="label">Bairro</span>
          <span class="value">{{ client.address.neighborhood }}</span>
        </template>
        <template v-if="client.address && client.address.complement">
          <span class="label">Complemento</span>
          <span class="value">{{ client.address.complement }}</span>
        </template>
        <template v-if="client.address && client.address.city">
          <span class="label">Cidade</span>
          <span class="value">{{ client.address.city }}</span>
        </template>
        <template v-if="client.address && client.address.state">
          <span class="label">Estado</span>
          <span class="value">{{ client.address.state }}</span>
        </template>
      </div>
    </div>

    <div v-if="hasGeolocation" class="card-gray mt-4">
      <h6 class="text-semibold mb-4">Geolocalização</h6>
      <div class="info-grid">
        <template v-if="client.country_code">
          <span class="label">Código do país</span>
          <span class="value">{{ client.country_code }}</span>
        </template>
        <template v-if="client.country_name">
          <span class="label">País</span>
          <span class="value">{{ client.country_name }}</span>
        </template>
        <template v-if="client.region_name">
          <span class="label">Região</span>
          <span class="value">{{ client.region_name }}</span>
        </template>
        <template v-if="client.city_name">
          <span class="label">Cidade</span>
          <span class="value">{{ client.city_name }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: Object
  },
  methods: {
    copyEmail() {
      const email = this.client?.email;
      if (!email) return;

      const fallbackCopy = () => {
        const textarea = document.createElement("textarea");
        textarea.value = email;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        textarea.style.top = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          const success = document.execCommand("copy");
          document.body.removeChild(textarea);
          return success;
        } catch (err) {
          document.body.removeChild(textarea);
          return false;
        }
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(email).then(() => {
          this.$message.success("E-mail copiado");
        }).catch(() => {
          if (fallbackCopy()) {
            this.$message.success("E-mail copiado");
          } else {
            this.$message.error("Não foi possível copiar o e-mail");
          }
        });
      } else if (fallbackCopy()) {
        this.$message.success("E-mail copiado");
      } else {
        this.$message.error("Não foi possível copiar o e-mail");
      }
    }
  },
  computed: {
    hasAddress() {
      const addr = this.client?.address;
      return (
        addr?.zipcode ||
        addr?.address ||
        addr?.number ||
        addr?.neighborhood ||
        addr?.complement ||
        addr?.city ||
        addr?.state
      );
    },
    hasGeolocation() {
      return (
        this.client?.country_code ||
        this.client?.country_name ||
        this.client?.region_name ||
        this.client?.city_name
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.reports-client-details {
  .card-gray {
    background: var(--bg-2);
    padding: 24px;
    border-radius: 16px;
  }
  .info-grid {
    display: grid;
    grid-template-columns: minmax(150px, 180px) 1fr;
    row-gap: 16px;
    column-gap: 24px;

    @media screen and (max-width: 991px) {
      grid-template-columns: minmax(100px, 150px) 1fr;
    }
  }
  .label {
    color: var(--dark-40);
    font-weight: 500;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .value {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .value-copyable {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    .copy-icon {
      opacity: 0.5;
      font-size: 14px;
      flex-shrink: 0;
    }
    &:hover .copy-icon {
      opacity: 1;
    }
  }
}
</style>
